import styled from 'styled-components';
import { LuUserPlus2 } from 'react-icons/lu';

export const StyledForm = styled.form`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const StyledIconAddContact = styled(LuUserPlus2)`
  font-size: 1.5rem;
`;
